import store from '../store/index'
//---------------------
// get fatigue options
//---------------------
export default function getFatigueOptions(cur_fatigue) {
  //------------------
  // get all fatigues
  //------------------
  const this_store = store
  const fatigues = this_store.getters['combat/getFatigues']
  //---------------------------------------
  // get available fatigues (excl current)
  //---------------------------------------
  return fatigues.filter((a) => a.name != cur_fatigue)
}
